var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "mb-6 text-xl font-bold" }, [
        _vm._v(" " + _vm._s(_vm.$t("trial.downloadWindows.title")) + " ")
      ]),
      _c(
        "va-card",
        { staticClass: "pa-6 mb-4" },
        [
          _c("div", { staticClass: "download-section" }, [
            _c("div", { staticClass: "download-section__header mb-4" }, [
              _c("p", { staticClass: "font-bold text-lg" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("trial.downloadWindows.magoRoom")) + " "
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "d-flex justify-center" },
              [
                _c("va-button", {
                  attrs: {
                    cta: _vm.$t("trial.downloadWindows.downloadExe"),
                    loading: _vm.downloading
                  },
                  on: { click: _vm.downloadExe }
                })
              ],
              1
            )
          ]),
          _vm.controllerIos || _vm.controllerAndroid
            ? _c("v-divider", { staticClass: "my-6" })
            : _vm._e(),
          _vm.controllerIos || _vm.controllerAndroid
            ? _c("div", { staticClass: "download-section" }, [
                _c("div", { staticClass: "download-section__header mb-4" }, [
                  _c("p", { staticClass: "font-bold text-lg" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("trial.downloadWindows.controller")) +
                        " "
                    )
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass: "d-flex justify-center flex-wrap",
                    staticStyle: { gap: "16px" }
                  },
                  [
                    _vm.controllerIos
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "store-badge d-flex flex-column align-center",
                            attrs: {
                              href: _vm.controllerIos.url,
                              target: "_blank"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                height: "50px",
                                width: "auto",
                                display: "block"
                              },
                              attrs: {
                                src: require("@/assets/images/badges/ios.svg"),
                                alt: "App Store"
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "store-badge__label mt-2 text-lg"
                              },
                              [_vm._v("App Store")]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.controllerAndroid
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "store-badge d-flex flex-column align-center",
                            attrs: {
                              href: _vm.controllerAndroid.url,
                              target: "_blank"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                height: "50px",
                                width: "auto",
                                display: "block"
                              },
                              attrs: {
                                src: require("@/assets/images/badges/android.svg"),
                                alt: "Google Play"
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "store-badge__label mt-2 text-lg"
                              },
                              [_vm._v("Google Play")]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "d-flex justify-end align-center flex-wrap",
          staticStyle: { gap: "8px" }
        },
        [
          _c("va-button", {
            attrs: { type: "outline", cta: _vm.$t("trial.back") },
            on: {
              click: function($event) {
                return _vm.$emit("prev")
              }
            }
          }),
          _c("va-button", {
            attrs: { cta: _vm.$t("trial.installationComplete") },
            on: {
              click: function($event) {
                return _vm.$emit("next")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }